import hblogin from '../../api/axios';
import Auth from '../auth/AuthService';
import { ELanguage } from '../../models/enums/language';
import { IForm } from '../../models/form/form';
import ILocal from '../../models/local';
import IFloor from '../../models/floor';
import IBuilding from '../../models/building';
import qs from 'qs';
import { IPropertyGroup } from '../../models/propertyGroup';

class FormService {
    GetFormTemplates = async (companyId: number, guid: string) => {
        const url = '/api/hblogin/form/GetCompanyFormTemplates';
        return (
            await hblogin.get<IForm[]>(url, {
                headers: {
                    AuthorizationHeader: process.env.REACT_APP_REPOSITORY_KEY || '',
                    Authorization: guid,
                },
                params: { companyId }
            })
        ).data;
    }

    DeleteFormTemplateByGroupId = async (groupId: number) => {
        const url = '/api/hblogin/form/DeleteFormTemplateByGroupId';
        return (
            await hblogin.delete(url, {
                headers: { Authorization: Auth.guid },
                params: { groupId }
            })
        ).data;
    }

    PostAllFormTemplate = async (form: IForm) => {
        const url = '/api/hblogin/form/PostAllFormTemplate';
        const response = (
            await hblogin.post(url, JSON.stringify(form), {
                headers: { Authorization: Auth.guid }
            }
            ))

        if (response.status && response.status == 200) return response.data;
        throw response;
    }

    PutFormTemplate = async (form: IForm) => {
        const url = '/api/hblogin/form/PutFormTemplate';
        const response = (
            await hblogin.put(url, JSON.stringify(form), {
                headers: { Authorization: Auth.guid }
            }
            ))

        if (response.status && response.status == 200) return response.data;
        throw response;
    }

    PostFilledForm = async (form: IForm) => {
        const url = '/api/hblogin/form/PostFilledForm';
        return (
            await hblogin.post(url, JSON.stringify(form), {
                headers: {
                    AuthorizationHeader: process.env.REACT_APP_REPOSITORY_KEY || '',
                    Authorization: Auth.guid,
                }
            })
        ).data;

    }

    SendFormEmail = async (form: IForm) => {
        const url = '/api/hblogin/form/SendFormEmail';
        return (
            await hblogin.post(url, JSON.stringify(form), {
                headers: {
                    AuthorizationHeader: process.env.REACT_APP_REPOSITORY_KEY || ''
                }
            })
        ).data;

    }

    GetFilledForms = async () => {
        const url = '/api/hblogin/form/GetFilledForms';
        return (
            await hblogin.get<IForm[]>(url, {
                headers: {
                    Authorization: Auth.guid,
                }
            })
        ).data;
    }

    UploadImages = async (images: FormData) => {
        const url = '/api/hblogin/form/UploadImages';
        return (
            await hblogin.post<string[]>(url, images, {
                headers: {
                    AuthorizationHeader: process.env.REACT_APP_REPOSITORY_KEY || '',
                    'Content-Type': 'multipart/form-data'
                }
            })
        ).data;
    }

    GetImageUrls = async (imageKeys: String[]) => {
        const url = '/api/hblogin/form/GetImageUrls';
        return (
            await hblogin.get<string[]>(url, {
                headers: {
                    Authorization: Auth.guid,
                    "Content-Type": 'application/json',
                },
                params: { imageKeys },
                paramsSerializer: (params) => {
                    return qs.stringify(params);
                },
            })
        ).data;
    }

    GetLocal = async (localId: number) => {
        const url = '/api/hblogin/visitor/GetLocal';
        return (
            await hblogin.get<ILocal>(url, {
                headers: {
                    AuthorizationHeader: process.env.REACT_APP_REPOSITORY_KEY || '',
                },
                params: { localId }
            })
        ).data;
    }

    GetLocalByServicePlusStickerCode = async (servicePlusStickerCode: string) => {
        const url = '/api/hblogin/visitor/GetLocalByServicePlusStickerCode';
        return (
            await hblogin.get<ILocal>(url, {
                headers: {
                    AuthorizationHeader: process.env.REACT_APP_REPOSITORY_KEY || '',
                },
                params: { servicePlusStickerCode }
            })
        ).data;
    }

    GetFloor = async (floorId: number) => {
        const url = '/api/hblogin/visitor/GetFloor';
        return (
            await hblogin.get<IFloor>(url, {
                headers: {
                    AuthorizationHeader: process.env.REACT_APP_REPOSITORY_KEY || '',
                },
                params: { floorId }
            })
        ).data;
    }

    GetBuilding = async (buildingId: number) => {
        const url = '/api/hblogin/visitor/GetBuilding';
        return (
            await hblogin.get<IBuilding>(url, {
                headers: {
                    AuthorizationHeader: process.env.REACT_APP_REPOSITORY_KEY || '',
                },
                params: { buildingId }
            })
        ).data;
    }

    GetPropertyGroup = async (propertyGroupId: number) => {
        const url = '/api/hblogin/visitor/GetPropertyGroup';
        return (
            await hblogin.get<IPropertyGroup>(url, {
                headers: {
                    AuthorizationHeader: process.env.REACT_APP_REPOSITORY_KEY || '',
                },
                params: { propertyGroupId }
            })
        ).data;
    }
}

export default new FormService();
